import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_sst_02,
    getReportLabel: () => t`SST-02`,
    getColumns: () => [],
};
